import {
    IEntity,
    IPagedSearchParams,
    ITypeEntityFragment,
} from '@pf/shared-common';
import {
    ResourceAuth,
    UserPositionSearchRequestParams,
    UserPositionViewModelCreateBody,
    UserPositionViewModelRead,
} from '@control-tower/platform-core';

export type UserPositionRead = UserPositionViewModelRead & IEntity;
export type UserPositionCreate = UserPositionViewModelCreateBody;
export type UserPositionSearchParams = UserPositionSearchRequestParams &
    IPagedSearchParams;

export class UserPositionDto implements IEntity {
    constructor(data: Partial<UserPositionDto>) {
        Object.assign(this, data);
    }

    id!: string;
    isDeleted?: boolean;
    createdDate?: string;
    modifiedDate?: string;
    userId?: string;
    userFirstName?: string;
    userLastName?: string;
    userEmail?: string;
    locationId?: string;
    locationName?: string;
    userPositionTypeId?: string;
    userPositionTypeName?: string;
    enteredDateTime?: string;
    exitedDateTime?: string;
    status?: string;
    timeInPosition?: number;
    context?: object;
    resourceAuth?: ResourceAuth;

    get name() {
        return this.userPositionTypeName;
    }
}
